import { render, staticRenderFns } from "./SWPCalculator.vue?vue&type=template&id=66ca5f66&scoped=true"
import script from "./SWPCalculator.vue?vue&type=script&lang=js"
export * from "./SWPCalculator.vue?vue&type=script&lang=js"
import style0 from "./SWPCalculator.vue?vue&type=style&index=0&id=66ca5f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca5f66",
  null
  
)

export default component.exports